import React, { useState, useRef } from 'react';
import { SelectedPlanActionMenuButton } from './PlanActionMenu.styles';
import {
  Menu,
  MenuContent,
  MenuTrigger,
  MenuItem,
  MenuSeparator,
} from '../../../CommonComponents/OPL/Menu/Menu';
import { ListItem } from '../../../CommonComponents/OPL/List/ListItem';
import { CopyPlanModal } from '../CopyPlanModal/CopyPlanModal';
import { NewPlanModal } from '../NewPlanModal/NewPlanModal';
import { EditPlanModal } from '../EditPlanModal/EditPlanModal';
import { DeletePlanModal } from '../DeletePlanModal/DeletePlanModal';
import { useSelectedPlan } from '../../hooks/useSelectedPlan';

enum PlanModals {
  Copy,
  New,
  Edit,
  Delete,
}

export const PlanActionMenu = () => {
  const selectedPlan = useSelectedPlan();

  const [planModalOpen, setPlanModalOpen] = useState<PlanModals | null>(null);

  const triggerRef = useRef<HTMLButtonElement>(null);

  if (!selectedPlan) {
    return null;
  }

  const { isCurrent: selectedPlanIsCurrent } = selectedPlan;

  return (
    <>
      {planModalOpen === PlanModals.Copy && (
        <CopyPlanModal
          closeModal={() => {
            setPlanModalOpen(null);

            if (triggerRef.current) {
              triggerRef.current.focus();
            }
          }}
        />
      )}

      {planModalOpen === PlanModals.New && (
        <NewPlanModal
          closeModal={() => {
            setPlanModalOpen(null);

            if (triggerRef.current) {
              triggerRef.current.focus();
            }
          }}
        />
      )}

      {planModalOpen === PlanModals.Edit && (
        <EditPlanModal
          closeModal={() => {
            setPlanModalOpen(null);

            if (triggerRef.current) {
              triggerRef.current.focus();
            }
          }}
        />
      )}

      {planModalOpen === PlanModals.Delete && (
        <DeletePlanModal
          closeModal={() => {
            setPlanModalOpen(null);

            if (triggerRef.current) {
              triggerRef.current.focus();
            }
          }}
        />
      )}

      <Menu>
        <MenuTrigger>
          <SelectedPlanActionMenuButton ref={triggerRef} />
        </MenuTrigger>

        <MenuContent width={176} align="start">
          <MenuItem
            onSelect={evt => {
              evt.preventDefault();
              setPlanModalOpen(PlanModals.New);
            }}
          >
            <ListItem icon="far fa-plus-circle">New Plan</ListItem>
          </MenuItem>

          <MenuItem
            onSelect={evt => {
              evt.preventDefault();
              setPlanModalOpen(PlanModals.Edit);
            }}
          >
            <ListItem icon="fas fa-pencil">Edit Plan</ListItem>
          </MenuItem>

          <MenuItem
            onSelect={evt => {
              evt.preventDefault();
              setPlanModalOpen(PlanModals.Copy);
            }}
          >
            <ListItem icon="far fa-clone">Copy Plan</ListItem>
          </MenuItem>

          {!selectedPlanIsCurrent && (
            <>
              <MenuSeparator />
              <MenuItem
                onSelect={evt => {
                  evt.preventDefault();
                  setPlanModalOpen(PlanModals.Delete);
                }}
              >
                <ListItem icon="far fa-trash-alt" variant="error">
                  Delete
                </ListItem>
              </MenuItem>
            </>
          )}
        </MenuContent>
      </Menu>
    </>
  );
};
